const initialState = {
	health: {},
	clusterHealth: {},
	nodeStatus: { healthy: true, downNodes: [] },
	failoverDialog: { open: false, acked: false },
	hasHealthError: false,
	hasApiError: false,
	bytesReceived: [],
	totalBytesReceived: 0,
	connected: false,
	online: true
};

const systemHealth = (state = initialState, action) => {
	const { type, payload } = action;
	switch (type) {
		case "SYSTEM_HEALTH_RECEIVED": {
			const hasError = Object.keys(payload).find((key) => {
				const data = payload[key];
				return data.error === true;
			});
			return {
				...state,
				health: payload,
				hasHealthError: !!hasError,
				hasApiError: false
			};
		}

		case "CLUSTER_HEALTH_RECEIVED": {
			return {
				...state,
				clusterHealth: payload
			};
		}

		case "NODE_STATUS_RECEIVED": {
			let failoverDialogOpen = state.failoverDialog.open;
			if (!failoverDialogOpen) {
				failoverDialogOpen = state.nodeStatus.healthy && !payload.cluster.healthy && !state.failoverDialog.open;
			}
			const failoverDialogAcked = failoverDialogOpen ? false : state.failoverDialog.acked;
			return {
				...state,
				nodeStatus: payload.cluster,
				failoverDialog: { open: failoverDialogOpen, acked: failoverDialogAcked },
				clusterHealth: payload.health
			};
		}

		case "CLUSTER_FAILOVER_CONFIRMED": {
			return {
				...state,
				failoverDialog: { open: state.open, acked: true }
			};
		}

		case "SYSTEM_HEALTH_ERROR": {
			return {
				...state,
				hasApiError: true
			};
		}

		case "LOG_DATA_RECEIVED": {
			const { bytesReceived, totalBytesReceived } = state;
			const bucketInterval = 1000; // 1-second intervals
			const bucketKey = Math.floor(Date.now() / bucketInterval) * bucketInterval;

			// Round the timestamp down to the nearest second
			const roundedTimestamp = Math.floor(bucketKey / 1000) * 1000;

			// Find or create the current bucket
			let bucket = bytesReceived.find((b) => b.timestamp === roundedTimestamp);
			if (!bucket) {
				bucket = { timestamp: roundedTimestamp, bytes: 0 };
				bytesReceived.push(bucket);
			}

			// Add the payload to the current bucket
			bucket.bytes += payload.bytesReceived;

			// Filter to keep only the last 2 minutes of data
			const twoMinutesAgo = Date.now() - 120000;
			const updatedBytesReceived = bytesReceived.filter((b) => b.timestamp >= twoMinutesAgo);

			// Update the total bytes received
			const updatedTotalBytesReceived = totalBytesReceived + payload.bytesReceived;

			return {
				...state,
				bytesReceived: updatedBytesReceived,
				totalBytesReceived: updatedTotalBytesReceived
			};
		}

		case "SYSTEM_HEALTH_CONNECTED_CHANGED": {
			return {
				...state,
				connected: payload
			};
		}
		case "SYSTEM_HEALTH_ONLINE_CHANGED": {
			return {
				...state,
				online: payload
			};
		}

		default:
			return state;
	}
};

export default systemHealth;
